import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { borderRadii, gutters, layers } from 'app/spacing';
import { Table } from 'components/Kizen/Table';

export const TABLE_HEADER_HEIGHT = 50;
export const TABLE_ROW_HEIGHT = 40;

export const BasicTableWrapper = styled.div`
  width: 100%;
  flex: 1;
  background-color: var(--color-background-white);
  border-radius: ${borderRadii.small};
  overflow-y: hidden;
  flex-direction: column;
  position: relative;
  height: 100%;
  > div {
    position: relative;
    height: 100%;
  }
`;

export default styled(Table)`
  width: 100%;
  margin-bottom: ${gutters.spacing(4, -17)}px;
  ${({ minHeight }) =>
    minHeight &&
    css`
      min-height: ${minHeight}px;
    `}
  thead > tr {
    height: ${TABLE_HEADER_HEIGHT}px;
  }

  tbody > tr {
    height: ${TABLE_ROW_HEIGHT}px;
    &:hover {
      background-color: var(--color-background-hover);
    }
    > td {
      height: ${TABLE_ROW_HEIGHT}px;
    }
  }

  tbody > tr.active {
    background-color: var(--color-background-hover);
  }

  ${({ height }) =>
    typeof height !== 'undefined'
      ? css`
          height: ${height}px;
        `
      : ''}
  ${({ compactHeader }) =>
    // This is often used alongside "tall" toolbars
    compactHeader &&
    css`
      thead > tr {
        height: 42px;
      }
    `}
  ${({ stickyHeader }) =>
    stickyHeader &&
    css`
      border-collapse: separate; // Ensures bottom border on sticky th doesn't scroll away
      thead > tr {
        th {
          position: sticky;
          top: 0;
          z-index: ${layers.content(0, 1)}; // Appear above cell contents
          background-color: var(--color-background-white);
          border-bottom: 1px solid var(--color-border-medium-light);
        }
      }
    `}
  transition: opacity 0.3s ease-in-out;
  ${({ staleData }) =>
    staleData &&
    css`
      tbody {
        opacity: 0.5;
      }
    `}
`;
